module.exports = __webpack_public_path__ + "static/media/Thank_u.09b4a1df.png";